import { createSelector } from 'reselect';
const getState = (state) => state;
export const getIsLoading = createSelector(getState, state => state.loading);
export const getAirports = createSelector(getState, state => state.airports);
export const getFlights = createSelector(getState, state => state.flights.filter(flight => flight.departure.airport.latitude &&
    flight.departure.airport.longitude &&
    flight.arrival.airport.longitude &&
    flight.arrival.airport.longitude));
export const getSelectedFlight = createSelector(getState, state => state.activeFlight);
export const getSelectedAirport = createSelector(getState, state => state.activeAirport);
export const getLastUpdate = createSelector(getState, state => state.lastUpdate);
export const getHoveredAirport = createSelector(getState, state => state.hoveredAirport);
export const getHoveredFlight = createSelector(getState, state => state.hoveredFlight);
export const getFlightsInSky = createSelector(getFlights, flights => {
    return flights.filter(flight => flight.pathCompletion < 100 && flight.pathCompletion > 0);
});
export const getUniqueFlights = createSelector(getFlights, flights => {
    const flightDepArrExistingMap = new Map();
    const uniqueFlights = [];
    for (const flight of flights) {
        const departureArrival = `${flight.departure.airport.iata}-${flight.arrival.airport.iata}`;
        const arrivalDeparture = `${flight.arrival.airport.iata}-${flight.departure.airport.iata}`;
        if (flightDepArrExistingMap.has(departureArrival) || flightDepArrExistingMap.has(arrivalDeparture)) {
            continue;
        }
        else {
            flightDepArrExistingMap.set(departureArrival, true);
            flightDepArrExistingMap.set(arrivalDeparture, true);
            uniqueFlights.push(flight);
        }
    }
    return uniqueFlights;
});
